"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteAttributesFromSeveralNodes = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const graphql_1 = require("../../../../__generated__/graphql");
const product_tree_nodes_1 = require("../../product-tree-nodes");
const delete_attribute_mutation_1 = require("../delete-attribute.mutation");
const useDeleteAttributesFromSeveralNodes = () => {
    const [deleteAttributeMutation] = (0, react_2.useMutation)(delete_attribute_mutation_1.DELETE_ATTRIBUTE);
    const deleteAttributesFromSeveralNodes = (0, react_1.useCallback)((attributeLabels, treeNodeIds) => __awaiter(void 0, void 0, void 0, function* () {
        const variableList = [];
        for (const label of attributeLabels) {
            for (const treeNodeId of treeNodeIds) {
                variableList.push([label, treeNodeId]);
            }
        }
        const promises = variableList.map(([attributeId, treeNodeId]) => new Promise((resolve, reject) => {
            void deleteAttributeMutation({
                variables: {
                    productLabelValidation: {
                        label: attributeId,
                        productTreeNode: treeNodeId,
                        clientMutationId: '',
                        includeDescendants: true,
                        includeAncestors: false,
                    },
                    sort: [{ distance: graphql_1.SortOrder.Asc }],
                },
                onError: (error) => reject(new Error(error.message)),
                onCompleted: (data) => resolve(data.deleteProductLabelValidation),
            });
        }));
        const results = yield Promise.all(promises);
        const errors = results.filter(({ error }) => error).map(({ error }) => error);
        const errorMessage = errors.join(', ');
        if (errorMessage) {
            throw new Error(errorMessage);
        }
        const updatedPaths = (0, product_tree_nodes_1.getTreeNodePaths)(results.map(({ productTreeNode }) => productTreeNode));
        return updatedPaths;
    }), [deleteAttributeMutation]);
    return {
        deleteAttributesFromSeveralNodes,
    };
};
exports.useDeleteAttributesFromSeveralNodes = useDeleteAttributesFromSeveralNodes;
exports.default = exports.useDeleteAttributesFromSeveralNodes;
